module.exports = __webpack_public_path__ + "img/aParty_032523_G.b87ffd6c.jpg";